import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Hlhts" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "emq-table-footer" }

import { getHlhtList, banHlhtConfig, hlhtRefreshToken, deleteHlhtConfig } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat, throttleBtn } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import {
  ArrowDown,
  ArrowUp,
  Refresh,
  RefreshLeft,
  Search,
  Plus,
  Message,
} from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import HlhtUpsert from './components/HlhtUpsert.vue'
import HlhtAuths from './components/HlhtAuths.vue'
import { Ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkMenuShow } from '@/store/tool'
import { HLHTProtocol } from '@/types/types'


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Hlhts',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const showAuthDialog = ref(false)
const showDialog = ref(false)
const showIsEdit = ref(false)
const showHlht: Ref<undefined | Record<string, any>> = ref(undefined)
const showAuthHlht: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { getHLHTProtocolDesc } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('Hlhts-detail')

const deleteConfig = async (hlht: any) => {
  try {
    await ElMessageBox.confirm(t('Operation.confirmDeleteConfig'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })

    await deleteHlhtConfig({ id: hlht.id })
    loadTableData()
    ElMessage.success(t('Base.opSuccess'))
  } catch (error) {
    console.error(error)
  }
}

const refreshToken = async (hlht: any) => {
  try {
    await ElMessageBox.confirm(t('Operation.confirmRefreshToken'), {
      confirmButtonText: t('Base.confirm'),
      cancelButtonText: t('Base.cancel'),
      confirmButtonClass: 'confirm-danger',
      type: 'warning',
    })

    await hlhtRefreshToken({ configId: hlht.id })
    ElMessage.success(t('Base.opSuccess'))
  } catch (error) {
    console.error(error)
  }
}

const openAuth = (Hlht: any) => {
  showAuthDialog.value = true
  showAuthHlht.value = Hlht
}

const addHlht = () => {
  showDialog.value = true
  showHlht.value = undefined
  showIsEdit.value = false
}

const editHlht = (Hlht: any) => {
  showDialog.value = true
  showHlht.value = Hlht
  showIsEdit.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  console.log('params', params.value)
  loadTableData({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const handleSwitchStatus = async (row: any) => {
  try {
    await banHlhtConfig({ id: row.id, enable: row.enable })
    ElMessage.success(t('Base.opSuccess'))
    loadTableData()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}
const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, name } = params
  newParams = {
    id: id || undefined,
    name: name || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getHlhtList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTableData)
loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                  placeholder: _ctx.$t('Base.id'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.name) = $event)),
                  placeholder: _ctx.$t('Base.name'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addHlht()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'hlhtAdd']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "80",
            label: _ctx.$t('Base.name'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                content: row.id,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(PreWithEllipsis, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "120",
            label: _ctx.$t('Operation.operator')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorId,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "proto",
            "min-width": "120",
            label: _ctx.$t('Evses.protocol')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getHLHTProtocolDesc)(row.proto)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "enable",
            label: _ctx.$t('Base.isEnabled')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_switch, {
                modelValue: row.enable,
                "onUpdate:modelValue": ($event: any) => ((row.enable) = $event),
                onChange: ($event: any) => (handleSwitchStatus(row)),
                disabled: !_unref(checkMenuShow)('hlhtUpsert')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "desc",
            "min-width": "120",
            label: _ctx.$t('Base.desc')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "updatedAt",
            "min-width": "100",
            label: _ctx.$t('Base.updatedAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.updatedAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "100",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "min-width": "200",
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editHlht(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'hlhtUpsert']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (openAuth(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Operation.hlhtAuthList')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'hlhtAuthOP']
              ]),
              (row.proto != _unref(HLHTProtocol).HP_AMAP)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    plain: "",
                    onClick: ($event: any) => (refreshToken(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Operation.refreshToken')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_role, 'hlhtUpsert']
                  ])
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (deleteConfig(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'hlhtDelete']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[3] || (_cache[3] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ]),
      _createVNode(HlhtUpsert, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDialog).value = $event)),
        isEdit: showIsEdit.value,
        info: showHlht.value,
        onSubmitted: loadTableData
      }, null, 8, ["modelValue", "isEdit", "info"]),
      _createVNode(HlhtAuths, {
        modelValue: showAuthDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showAuthDialog).value = $event)),
        info: showAuthHlht.value,
        onSubmitted: loadTableData
      }, null, 8, ["modelValue", "info"])
    ])
  ]))
}
}

})